import React from "react";

/**
 * Recrysta brand mark — the emerald crystal, rendered as inline SVG.
 * Scales crisply everywhere and needs no additional network request.
 * Colors are hardcoded to match the source PNG exactly.
 */
export const RecrystaMark = ({ size = 24, className = "", ariaHidden = true }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={size}
    height={size}
    className={className}
    role={ariaHidden ? "presentation" : "img"}
    aria-hidden={ariaHidden ? "true" : undefined}
    aria-label={ariaHidden ? undefined : "Recrysta"}
    data-testid="recrysta-mark"
  >
    <polygon points="50,4 50,50 4,50" fill="#14755A" />
    <polygon points="50,4 96,50 50,50" fill="#6FCBA8" />
    <polygon points="4,50 50,50 50,96" fill="#1D9E75" />
    <polygon points="50,50 96,50 50,96" fill="#3DB68C" />
  </svg>
);

/**
 * Full lockup — crystal mark + "Recrysta" wordmark.
 * Use where there's horizontal room (nav, footer, auth pages).
 */
export const RecrystaLogo = ({
  size = 24,
  className = "",
  textClassName = "text-sm font-bold tracking-tight text-slate-900",
}) => (
  <span
    className={`inline-flex items-center gap-2 ${className}`}
    data-testid="recrysta-logo"
  >
    <RecrystaMark size={size} />
    <span className={textClassName}>Recrysta</span>
  </span>
);

export default RecrystaLogo;
